<template>
  <div>
    <v-row>
      <v-card>
        <v-card-title>
          <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
          ></v-text-field>
        </v-card-title>
            <v-data-table
                    :search="search"
                    :headers="headers"
                    :items="id_records"
                    :items-per-page="15"
                    class="elevation-1"
            ></v-data-table>
        <v-card-actions>
          <vue-json-to-csv :json-data="id_records" :csv-title="relay.relay_name + ' ID'">
            <v-btn>
              Download as CSV
            </v-btn>

          </vue-json-to-csv>


        </v-card-actions>
      </v-card>
    </v-row>
  </div>
</template>

<script>
  import VueJsonToCsv from 'vue-json-to-csv';
  export default {
    name: 'RelayIdTable',
    data: () => ({
      search: '',
      headers: [
        {
          text: "Time",
          value: "time"
        },
        {
          text: "FID",
          value: "fid"
        },
        {
          text: "BFID",
          value: "bfid"
        },
        {
          text: "CID",
          value: "cid"
        },
        {
          text: "DEVID",
          value: "devid"
        },
        {
          text: "devcode",
          value: "devcode"
        },
        {
          text: "Part Number",
          value: "partno"
        },
        {
          text: "Serial Number",
          value: "serialno"
        },
        {
          text: "Config",
          value: "config"
        },
        {
          text: "Special",
          value: "special"
        }

      ],

      panel: [0,1],
      menu: false,
      meterChart: {}
    }),
    props: {
      relay: {
        type: Object,
        required: true
      },
      id_records: {
        type: Array,
        required: true
      }
    },
    computed:{
    },
    methods:{


    },
    mounted() {
      console.log("RelayIdTable");
    },
    components:{
      VueJsonToCsv
    },

  }
</script>
